import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

import { environment } from '@app/env-service';

@Injectable({
  providedIn: 'root',
})
export class PipelineService {
  url :string = environment.url;

  private readonly _pipelines = new BehaviorSubject<any>(<any>[]);
  public pipelines$ = this._pipelines.asObservable();

  public gettingRecords :boolean = false;

  priorities :any[] = [
    { id: 10, label: 'Low' },
    { id: 20, label: 'Medium' },
    { id: 30, label: 'High' },
  ];
  constructor(
    private translate :TranslateService,
    private http :HttpClient,
  ) {
    this.get({});
  }

  get(params) {
    this.gettingRecords = true;

    return this.http
      .get(`${this.url}/pipelines`, { params: params })
      .subscribe((resp :any) => {
        this.gettingRecords = false;
        this._pipelines.next(resp);
      });
  }

  updatePipelineStageSortOrder(
    pipelineId :number,
    pipelineStageId :number,
    payload,
  ) {
    // return of([]);
    return this.http.post(
      `${this.url}/pipelines/${pipelineId}/stage/${pipelineStageId}/designs`,
      payload,
    );
  }

  duplicatePipeline(pipelineId :number) :Observable<any> {
    return this.http.post(`${this.url}/pipelines/${pipelineId}/duplicate`, {});
  }

  getById(pipelineId :number) :Observable<any> {
    return this.http.get(`${this.url}/pipelines/${pipelineId}`);
  }

  updatePipeline(pipelineId :number, payload :any) :Observable<any> {
    return this.http.post(`${this.url}/pipelines/${pipelineId}`, payload).pipe(
      tap((resp :any) => {
        this.tryUpdateOrAddResp(resp);
      }),
    );
  }

  createPipeline(payload :any) :Observable<any> {
    return this.http.post(`${this.url}/pipelines`, payload).pipe(
      tap((resp :any) => {
        setTimeout(() => {
          const pipelines :any = this._pipelines.getValue();
          if (pipelines && pipelines.data) {
            if (resp && resp.fees) {
              resp.fees = JSON.parse(resp.fees);
            }
            pipelines.data.splice(0, 0, resp);
            this._pipelines.next(pipelines);
          }
        });
      }),
    );
  }

  deletePipeline(pipelineId :number) {
    return this.http.delete(`${this.url}/pipelines/${pipelineId}`).pipe(
      tap((resp :any) => {
        const pipelines :any = this._pipelines.getValue();
        const poIdx = pipelines.data.findIndex((row) => row.id == pipelineId);
        pipelines.data.splice(poIdx, 1);
        this._pipelines.next(pipelines);
      }),
    );
  }

  tryUpdateOrAddResp(resp) {
    const pipelines :any = this._pipelines.getValue();
    if (!pipelines || !pipelines.data) {
      return;
    }
    const poIdx = pipelines.data.findIndex((row) => row.id == resp.id);
    if (poIdx >= 0) {
      pipelines.data[poIdx] = resp;
    } else {
      pipelines.data.splice(0, 0, resp);
    }
    this._pipelines.next(pipelines);
  }

  transformPipelines(rfqPipelines :any) {
    if (!rfqPipelines) {
      return [];
    }
    const pipelines :any = this._pipelines.getValue();
    const tPipes :any[] = [];
    rfqPipelines.forEach((rp :any) => {
      const pipeline = pipelines.data.find((row) => row.id == rp.pipeline_id);
      if (pipeline) {
        const stage = pipeline.stages.find(
          (stage) => stage.id == rp.pipeline_stage_id,
        );
        if (stage) {
          rp.pipeline = pipeline;
          rp.stage = stage;
          tPipes.push(rp);
        }
      }
    });

    return tPipes;
  }

  getPipelineRfqs(pipelineId :number, params) {
    return this.http.get(`${this.url}/pipelines/${pipelineId}/rfqs`, {
      params: params,
    });
  }

  addRfqToPipeline(pipelineId :number, payload :any) {
    return this.http.post(`${this.url}/pipelines/${pipelineId}/rfqs`, payload);
  }

  getPipelineProductDesigns(pipelineId :number, params) {
    return this.http.get(`${this.url}/pipelines/${pipelineId}/product_designs`, {
      params: params,
    });
  }

  addProductDesignToPipeline(pipelineId :number, payload :any) {
    return this.http.post(
      `${this.url}/pipelines/${pipelineId}/product_designs`,
      payload,
    );
  }

  addTag(pipelineId :number, payload :any) :Observable<any> {
    return this.http.post(`${this.url}/pipelines/${pipelineId}/tags`, payload).pipe(
      tap((resp :any) => {
        this.updatePipelineRow(pipelineId, 'tags', payload);
      }),
    );
  }
  updateTag(pipelineId :number, tagId :number, payload :any) :Observable<any> {
    return this.http
      .post(`${this.url}/pipelines/${pipelineId}/tags/${tagId}`, payload)
      .pipe(
        tap((resp :any) => {
          this.updatePipelineRow(pipelineId, 'tags', payload);
        }),
      );
  }
  deleteTag(pipelineId :number, tagId :number) :Observable<any> {
    return this.http
      .delete(`${this.url}/pipelines/${pipelineId}/tags/${tagId}`)
      .pipe(
        tap((resp :any) => {
          this.updatePipelineRow(pipelineId, 'tags', tagId);
        }),
      );
  }

  updatePipelineRow(pipelineId, prop, payload :any) {}
}
